module.exports = __webpack_public_path__ + "img/skilllist_3.12824c32.png";